import React, { useEffect, useState } from 'react';
import AppRouter from 'common/AppRouter';
import { SPACES } from 'common/constants/sizes';
import {
  GrayBackground,
  Page,
  WhiteSection
} from 'components/base/layout-components';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import styled from 'styled-components';
import ActivityTabs from './ActivityTabs';
import BranchesV2 from './views/branchesV2';
import PullRequests from './views/pull-requests';
import { FEATURE_FLAGS_NAMES, TEAM_TYPE_MAP } from '@linearb/linjs-common';
import Releases from './views/releases';
import Incidents from './views/incidents';
import useSettingsService from 'components/hooks/useSettingsService';
import AllContributorsBanner from '../dashboard/doraV2/Widgets/AllContributorsBanner';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { useSelector } from 'react-redux';
import QueryString from 'qs';
import _ from 'lodash';

const StyledBackground = styled(GrayBackground)`
  padding: ${SPACES.small};
`;

const FlexedWhiteSection = styled(WhiteSection)`
  display: flex;
  flex-direction: column;
`;

const Activity = ({ resetPullRequests }) => {
  const selectedTeam = useSelector(selectedTeamSelector);
  const isAllContributorsSelected =
    selectedTeam?.type === TEAM_TYPE_MAP.ALL_CONTRIBUTORS;
  const [previousSelectedTeamId, setPreviousSelectedTeamId] = useState(
    selectedTeam?.id
  );

  const history = useHistory();
  useEffect(() => {
    if (!selectedTeam?.id || selectedTeam?.id === previousSelectedTeamId) {
      return;
    }
    const search = QueryString.parse(window.location.search, {
      ignoreQueryPrefix: true
    });

    const newSearchString = `?${QueryString.stringify(
      _.omit(search, ['filtered_teams'])
    )}`;
    history.replace({
      pathname: window.location.pathname,
      search: newSearchString
    });
    setPreviousSelectedTeamId(selectedTeam?.id);
  }, [selectedTeam?.id]);

  const { getSettingOrDefinitionValue } = useSettingsService();
  const isActivityReleasesEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isActivityReleasesEnabled
  });

  useEffect(() => {
    resetPullRequests();
  }, []);

  return (
    <Page>
      <StyledBackground>
        {isAllContributorsSelected && <AllContributorsBanner />}
        <FlexedWhiteSection height='100%'>
          <ActivityTabs />
          <Switch>
            <Route path={AppRouter.BRANCH.path} component={BranchesV2} />
            <Route
              path={AppRouter.PULL_REQUESTS.path}
              component={PullRequests}
            />
            {isActivityReleasesEnabled && (
              <Route
                path={AppRouter.RELEASES.path}
                render={() => <Releases withIncidentsCount={false} />}
              />
            )}
            <Route path={AppRouter.INCIDENTS.path} component={Incidents} />
            <Route
              path={AppRouter.ACTIVITY.path}
              exact
              render={() => (
                <Redirect
                  to={{
                    pathname: AppRouter.BRANCH.path,
                    search: window.location.search
                  }}
                />
              )}
            />
          </Switch>
        </FlexedWhiteSection>
      </StyledBackground>
    </Page>
  );
};

export default Activity;
